module.exports = "/_next/static/media/d0b923a98453f6ce87830c7a1c5c3b62.svg";